// src/hooks/useGlobalLoader.ts
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import { selectShowLoader } from '@/store/selectors/ui';
import { setShowLoader, setHideLoader } from '@/store/slices/ui/uiSlice';

export function useGlobalLoader() {
  const dispatch = useAppDispatch();
  const show = useSelector(selectShowLoader);

  const showLoader = useCallback(() => dispatch(setShowLoader()), [dispatch]);
  const hideLoader = useCallback(() => dispatch(setHideLoader()), [dispatch]);

  return { show, showLoader, hideLoader };
}
